import { Button, ButtonProps } from 'components/UI/Button';

type TogglePasswordProps = ButtonProps & {
  name?: string;
  visible: boolean;
};

const TogglePassword = ({ name, visible = false, ...props }: TogglePasswordProps) => (
  <Button
    size="sm"
    sx={{
      p: 2,
      borderRadius: 0,
      letterSpacing: 0,
    }}
    aria-label="Toggle Password"
    aria-controls={name}
    {...props}
  >
    {visible ? 'Hide' : 'Show'}
  </Button>
);

export default TogglePassword;
